import {queryKeys} from '../../constants/queryKey'
import {useQuery} from '@tanstack/react-query'
import {getUsers} from '../../api/users'

function useGetUsersQuery() {
  return useQuery([queryKeys.users], getUsers, {})
}

export default useGetUsersQuery
